export class Report {
    id: number;
    nome: string;
    description: string;
    tabela: any;
    campos: any;
    colunas: any;
    advanced: any;
    mostrartodos: boolean;
}



// WEBPACK FOOTER //
// ./src/app/report/report.ts